"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CURRENT_USER = void 0;
exports.CURRENT_USER = {
    id: "'120087074'",
    name: "'CSIEM E2E User (Full Permissions)'",
    displayName: "'CSIEM E2E User (Full Permissions)'",
    email: "'sbu-cse-ui+e2e@sumologic.com'",
    username: "'sbu-cse-ui+e2e@sumologic.com'",
    preferredTimezone: "'browser'",
};
